module.exports = __webpack_public_path__ + "img/16.57545a0e.jpg";